<template>
  <div>
    <v-app-bar dense elevation="0" height="50">
      <v-app-bar-nav-icon
        class="mx-1"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <!-- <v-toolbar-title>Title</v-toolbar-title> -->
      <!-- <v-avatar size="50">
        <v-img src="../assets/images/logo/namya_logo.png"></v-img>
      </v-avatar> -->
      <div class="show" v-for="item in items_menu" :key="item.title">
        <v-btn class="mx-1" elevation="0" rounded :to="item.path"
          ><h4>
            {{ item.title }}
          </h4>
        </v-btn>
      </div>
      <v-spacer class=""></v-spacer>
      <v-btn
        icon
        id="mode-switcher"
        @click="$vuetify.theme.dark = !$vuetify.theme.dark"
      >
        <v-icon :color="$vuetify.theme.dark ? 'warning' : 'warning lighten-3'">
          {{ $vuetify.theme.dark ? "mdi-weather-night" : "mdi-weather-sunny" }}
        </v-icon>
      </v-btn>
      <template>
        <div v-for="item in signinup" :key="item.title">
          <!-- <v-btn
            v-show="item.id == 1 || (item.id == 2 && token == null)"
            class="mx-1"
            elevation="0"
            rounded
            :to="item.path"
            >{{ item.title }}</v-btn
          > -->
          <v-btn class="mx-1" elevation="0" rounded :to="item.path">
            <h4>
              {{ item.title }}
            </h4>
          </v-btn>
        </div>
        <div class="text-center">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <picture>
                <source type="image/webp" :srcset="user.image" />
                <v-list-item-avatar>
                  <img
                    v-bind="attrs"
                    v-on="on"
                    v-show="!user.image"
                    src="../assets/images/no_user.jpg"
                    alt="nouser"
                  />
                  <img
                    v-bind="attrs"
                    v-on="on"
                    v-show="user.image"
                    :src="user.image"
                    :alt="user.name"
                  />
                </v-list-item-avatar>
              </picture>
            </template>

            <v-card>
              <v-list>
                <v-list-item>
                  <picture>
                    <source type="image/webp" :srcset="user.image" />
                    <v-list-item-avatar class="ml-3">
                      <img
                        v-show="!user.image"
                        src="../assets/images/no_user.jpg"
                        alt="nouser"
                      />
                      <img
                        v-show="user.image"
                        :src="user.image"
                        :alt="user.name"
                      />
                    </v-list-item-avatar>
                  </picture>

                  <v-list-item-content>
                    <v-list-item-title>{{ user.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      user.mobile
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  v-show="token == null"
                  color="primary"
                  text
                  @click="redirect()"
                >
                  ورود به حساب خود
                </v-btn>
                <v-btn
                  v-show="token != null"
                  color="primary"
                  text
                  @click="redirectprofile()"
                >
                  پروفایل
                </v-btn>
                <v-btn
                  v-show="token != null"
                  color="primary"
                  text
                  @click="logout()"
                >
                  خروج
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
        <!-- <v-btn
            v-show="item.id == 3 && token != null"
            class="mx-1"
            elevation="0"
            rounded
            @click="logout()"
            >{{ item.title }}</v-btn
          > -->
      </template>
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
        color="success accent-4"
      ></v-progress-linear>
    </v-app-bar>

    <!-- <v-col cols="12" class="text-center">
      <v-btn class="primary mt-5" @click="$vuetify.rtl = !$vuetify.rtl">
        Toglle RTL
      </v-btn>
    </v-col> -->

    <v-navigation-drawer
      class="rounded ma-2"
      v-model="drawer"
      :right="$vuetify.rtl"
      absolute
      temporary
    >
      <!-- <v-list-item>
        <v-list-item-avatar>
          <v-img src="../assets/images/logo/namya.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>نامیا</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list>
        <router-link
          style="text-decoration: none; color: grey"
          :to="{
            name: 'profile',
          }"
        >
          <v-list-item class="px-2" link>
            <v-list-item-avatar>
              <picture>
                <source type="image/webp" :srcset="user.image" />
                <img
                  v-show="!user.image"
                  src="@/assets/images/no_user.jpg"
                  alt="nouser"
                />
                <img v-show="user.image" :src="user.image" :alt="user.name" />
              </picture>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{ user.name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ user.mobile }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>

      <v-divider></v-divider>

      <v-list shaped dense>
        <v-list-item
          v-for="item in items_menu2"
          :key="'i' + item.title"
          link
          :href="item.path"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              ><h4>
                {{ item.title }}
              </h4>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  watch: {
    loading(val) {
      if (!val) return;

      setTimeout(() => (this.loading = false), 1000);
    },
  },
  data() {
    return {
      loading: false,
      drawer: false,
      token: null,
      fav: true,
      menu: false,
      message: false,
      hints: true,
      user: [],
      items_menu: [
        { id: 1, title: "خانه", path: "/home", icon: "mdi-view-dashboard" },
        { id: 2, title: "غرفه ها", path: "/", icon: "mdi-forum" },
        {
          id: 3,
          title: "اطراف من",
          path: "/aroundme",
          icon: "mdi-map-marker-radius",
        },
        // {
        //   id: 4,
        //   title: "فروشگاه من",
        //   path: "/c-template",
        //   icon: "mdi-store",
        // },
      ],
      items_menu2: [
        { id: 1, title: "خانه", path: "/home", icon: "mdi-view-dashboard" },
        { id: 2, title: "غرفه ها", path: "/", icon: "mdi-forum" },
        {
          id: 3,
          title: "اطراف من",
          path: "/aroundme",
          icon: "mdi-map-marker-radius",
        },
        {
          id: 4,
          title: "افزودن کسب و کار",
          path: "/createbooth",
          icon: "mdi-plus",
        },
        // { id: 5, title: "ورود", path: "/signin", icon: "mdi-forum" },
        // { id: 6, title: "خروج", path: "", icon: "mdi-forum" },
      ],
      signinup: [
        {
          id: 1,
          title: "افزودن کسب و کار",
          path: "/createbooth",
          icon: "mdi-view-dashboard",
        },
      ],
    };
  },
  mounted() {
    this.GetUser();
    this.loading = true;
    this.token = localStorage.token;
  },
  // destroyed() {
  //   localStorage.removeItem("token");
  //   this.token = null;
  // },
  computed: {},
  methods: {
    async GetUser() {
      var self = this;
      let response = await self.axios.get("https://namya.ir/api/v1/users", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      });
      self.user = response.data.data;
    },
    logout() {
      localStorage.removeItem("token");
      this.token = null;
      this.menu = false;
      window.location.reload();
    },
    redirect() {
      this.menu = false;
      this.$router.push({
        name: "signin",
      });
    },
    redirectprofile() {
      this.menu = false;
      this.$router.push({
        name: "profile",
      });
    },
  },
};
</script>

<style lang="css" scoped>
@media (max-width: 900px) {
  .show {
    display: none;
  }
}
.theme--light.v-btn:hover::before {
  opacity: 0.1 !important;
  background: gray;
  /* background: linear-gradient(
    219deg,
    rgba(10, 171, 148, 1) 35%,
    rgba(95, 188, 94, 1) 100%
  ); */
  color: #ffff;
}
.theme--light.v-btn--active::before,
.theme--light.v-btn--active::before {
  opacity: 0.2 !important;
  background: gray;
  /* background: linear-gradient(
    219deg,
    rgba(10, 171, 148, 1) 35%,
    rgba(95, 188, 94, 1) 100%
  ); */
}
.v-input {
  font-size: 14px !important;
  font-weight: 900;
}
.v-label {
  font-size: 14px !important;
}
h4 {
  font-weight: 200;
}
</style>
